// Flash Cards — plugin validateActivity.
// Local validation only. Does NOT reuse Concentration's validateConcentration
// (which requires matchTypes/cardsPerLevel and a six-card minimum — not applicable).

import { MODE, ALL_MODES, facesForMode, isItemFilled } from './flashCardsHelpers';

const isNonEmptyString = (v) => typeof v === 'string' && v.length > 0;

// Validate a single card for a given mode. Returns true/false.
export const validateProblemForMode = (mode, problem) => {
  if (!problem || !problem.id) return false;
  const items = problem.items || [];
  const faces = facesForMode(mode);

  if (mode === MODE.FILL_IN) {
    // one prompt item + a non-empty expected answer (empty/missing is invalid).
    if (items.length < 1 || !isItemFilled(items[0])) return false;
    if (!isNonEmptyString(problem.expectedAnswer)) return false;
    return true;
  }

  // memory / pick-one: two authored faces, both filled.
  if (items.length < faces) return false;
  for (let i = 0; i < faces; i += 1) {
    if (!isItemFilled(items[i])) return false;
  }

  if (mode === MODE.PICK_ONE) {
    const idx = problem.correctSideIndex;
    if (idx !== 0 && idx !== 1) return false;
  }

  return true;
};

// Build a validate(problem) bound to the current mode, for ProblemList's list
// rendering (visual validity only — ProblemList does not gate undo/delete on it).
export const makeValidate = (mode) => (problem) =>
  validateProblemForMode(mode, problem);

// Plugin-level validateActivity({ options, gameData }).
export default ({ options, gameData } = {}) => {
  if (!gameData) return false;

  const { mode, problems } = gameData;
  if (!ALL_MODES.includes(mode)) return false;
  if (!Array.isArray(problems) || problems.length === 0) return false;

  // Reject contradictory per-mode fields rather than silently coercing.
  for (const problem of problems) {
    if (mode !== MODE.FILL_IN && 'expectedAnswer' in problem) return false;
    if (mode !== MODE.PICK_ONE && 'correctSideIndex' in problem) return false;
    if (!validateProblemForMode(mode, problem)) return false;
  }

  return true;
};
